import { useEffect, useRef } from "react";
import { scrollToId } from "@/hooks/useScrollSpy";

// Secondary horizontal nav — subcategories of the active section.
// Sticky under the mobile primary nav, and at the top of content on desktop.
export const SubNav = ({ subcategories, activeSub }) => {
  const scrollerRef = useRef(null);
  const chipRefs = useRef({});

  // Keep the active chip in view as the user scrolls the page.
  useEffect(() => {
    const chip = chipRefs.current[activeSub];
    const scroller = scrollerRef.current;
    if (!chip || !scroller) return;
    const cLeft = chip.offsetLeft;
    const cRight = cLeft + chip.offsetWidth;
    const vLeft = scroller.scrollLeft;
    const vRight = vLeft + scroller.clientWidth;
    if (cLeft < vLeft + 16 || cRight > vRight - 16) {
      scroller.scrollTo({
        left: cLeft - scroller.clientWidth / 2 + chip.offsetWidth / 2,
        behavior: "smooth",
      });
    }
  }, [activeSub]);

  if (!subcategories || subcategories.length === 0) return null;
  return (
    <div
      data-testid="sub-nav"
      className="sticky top-[102px] z-20 -mx-5 border-b border-roty-line bg-roty-cream/95 px-5 backdrop-blur-md lg:top-0 lg:mx-0 lg:px-0"
    >
      <div
        ref={scrollerRef}
        className="no-scrollbar flex gap-2 overflow-x-auto py-2.5 lg:py-4"
        style={{ WebkitOverflowScrolling: "touch" }}
      >
        {subcategories.map((sub) => {
          const active = sub.id === activeSub;
          return (
            <button
              key={sub.id}
              ref={(el) => (chipRefs.current[sub.id] = el)}
              type="button"
              data-testid={`sub-nav-${sub.id}`}
              onClick={() => scrollToId(`sub-${sub.id}`)}
              className={`shrink-0 whitespace-nowrap rounded-full border px-4 py-2 text-[12px] font-extrabold uppercase tracking-wide transition-colors ${
                active
                  ? "border-roty-red bg-roty-red text-white"
                  : "border-roty-line bg-roty-paper text-roty-ink/80 hover:border-roty-gold hover:text-roty-red"
              }`}
            >
              {sub.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
